import React from "react";

export default function Network() {
  return (
    <>
      <section className="bg-midBlue py-20">
        <div className="max-w-6xl mx-auto  mlap:px-6 ">
          <div className="w-10/12">
            <h2 className="text-[35px] text-gray font-bold font-secondary leading-relaxed mb-4 lg:mb-0 mt-5">
              Our <span className="text-orange"> Network</span> of Professional
              Translators
            </h2>
            <p className="text-[#BEBEBE] text-base leading-8 font-opensans mt-2">
              That's why Tomedes utilizes a global network of translators. They
              are experts in their particular industry fields, such as medical
              and legal, while employing a mastery of their specific languages.
              We have available translators for your specific language needs
              like Spanish, Arabic, French, Swahili, and more.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
